<template>
  <div class='indexbox'>
    <div class="searchbox">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="val.shop_name" :name="val.id_tostrign" v-for="val in tablist" :key="val.shop_name">
        </el-tab-pane>
      </el-tabs>
      <div class="headersbox" v-if="tablist.length > 0">
        <el-form ref="form" style="min-width:40%;" size="small" inline>
          <el-form-item>
            <el-input v-model="title" :placeholder="$t('lg.输入并搜索')" clearable style="width: 120px"
              @change="pagechage(1)"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lg.状态')">
            <el-select v-model="status" :placeholder="$t('lg.请选择')" style="width: 120px" clearable
              @change="pagechage(1)">
              <el-option v-for="item in [{ label: $t('lg.未匹配'), value: 0 }, { label: $t('lg.已匹配'), value: 1 }]"
                :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="rightbox" style="min-width:40%;">
          <el-button type="primary" v-hasPermi="['import_goods']" @click="importgood">{{ $t('lg.导入') }}</el-button>
          <el-button type="primary" v-if="tabdata.is_full == 0" v-hasPermi="['download_goods']" :loading='sku_loading'
            @click="skuSyncAll">
            {{ $t('lg.商品全量下载') }}
          </el-button>
          <el-button type="primary" v-hasPermi="['download_goods']" :loading='btn_loadinga' @click="download">
            {{ $t('lg.下载平台商品') }}</el-button>
          <el-button type="primary" v-hasPermi="['match_goods']" :loading='btn_loadingb' @click="autoMatch">
            {{ $t('lg.商品自动匹配') }}
            <el-tooltip :content="$t('lg.自动匹配tip')" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </el-button>
          <el-button v-hasPermi="['del_goods']" type="primary" :loading='btn_allunbind' @click="deleteShop">{{
            $t('lg.删除商品')
          }}</el-button>
          <el-button type="primary" v-hasPermi="['save_goods']" :loading='btn_loadingc' @click="submit">{{ $t('lg.保存')
          }}
          </el-button>
        </div>
      </div>
    </div>
    <div class="tablebox">
      <div class="draggable" v-loading='loading'>
        <!-- //max-height='680px' -->
        <el-table :data="tableData" stripe @selection-change="SelectionChange" border>
          <el-table-column type="selection" fixed align='center' />
          <el-table-column :label="$t('lg.平台产品')" align='center'>
            <el-table-column prop="outerId" :label="$t('lg.产品代码')" min-width='110' align='left' />
            <el-table-column prop="refSkuId" :label="$t('lg.产品内码')" min-width='120' align='left'
              show-overflow-tooltip />
            <el-table-column prop="title" :label="$t('lg.产品名称')" min-width='120' align='left' show-overflow-tooltip />
            <el-table-column prop="standards" :label="$t('lg.规格型号')" min-width='100' align='left'
              show-overflow-tooltip />
          </el-table-column>
          <el-table-column :label="$t('lg.DEAR产品')" align='center' min-width='180'>
            <template slot-scope="scope">
              <p style="text-align:left;">{{ scope.row.dear_name }} </p>
              <el-select v-model="scope.row.dear_id" filterable remote :remote-method="searchlist" :loading="lloading"
                :placeholder="$t('lg.请选择')" v-hasPermi="['match_goods']"
                v-if="scope.row.status == 0 && tabdata && tabdata.status == 1">
                <el-option v-for="item in goodsList" :key="item.id" :label="item.sku_name" :value="item.id">
                </el-option>
                <el-pagination small layout="prev, pager, next" v-if="ltotala > 10" :total="ltotala"
                  @current-change="goodsListchange" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column :label="$t('lg.状态')" align='left' fixed='right' min-width="100">
            <template slot-scope="scope">
              <el-button type="text" size="small" v-if="scope.row.status == 0">{{ $t('lg.未匹配') }}</el-button>
              <el-popconfirm :title="$t('lg.确定要取消匹配吗')" v-else @confirm='cancelMatch(scope.row)'>
                <el-button slot="reference" type="text" size="small">{{ $t('lg.已匹配') }}</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination @current-change='pagechage' @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]"
        background layout="total,sizes,prev, pager, next" v-show="total > 0" :current-page.sync="page"
        :page-size="page_size" :total="total" />
    </div>
  </div>
</template>
<script>
  import ApiShop from './apiShop.vue';
  import { mapGetters } from 'vuex';
  export default {
    computed: {
      ...mapGetters(['api_id']),
    },
    components: { ApiShop },
    data() {
      return {
        tablist: [],
        tabdata: {},
        activeName: '',
        title: '',
        outerId: '',
        status: '',
        total: 0,
        page: 1,
        page_size: 10,
        tableData: [],
        loading: false,

        keywords: '',
        lpage: 1,
        ltotala: 0,
        lloading: false,
        goodsList: [],

        sku_loading: false,
        btn_loadinga: false,
        btn_loadingb: false,
        btn_loadingc: false,

        idsarr: [],
        btn_allunbind: false,
      };
    },
    methods: {
      // tab 店铺
      gettablist() {
        this.$post({
          url: "/app/member_shop/shopList",
          data: {
            page: 1,
            page_size: 1000,
            api_id: this.api_id
          },
          success: (res) => {
            res.data.data.forEach(item => {
              item.id_tostrign = item.id.toString()
            });
            this.tablist = res.data.data
            if (this.tablist.length > 0) {
              if (sessionStorage.getItem("goods_activeName")) {
                this.activeName = sessionStorage.getItem("goods_activeName")
              } else {
                this.activeName = res.data.data[0].id_tostrign
              }
              this.tabdata = this.tablist.find(data => data.id_tostrign == this.activeName)
            } else {
              sessionStorage.removeItem("goods_activeName")
            }
            this.$nextTick(() => {
              this.getlist()
            })
          },
          tip: () => {
          },
        })
      },
      handleClick(tab) {
        sessionStorage.setItem("goods_activeName", tab.name)
        this.activeName = tab.name
        this.tabdata = this.tablist.find(data => data.id_tostrign == this.activeName)
        this.pagechage(1)
      },
      // 列表
      getlist() {
        this.loading = true
        this.$post({
          url: "/app/goods/pageList",
          data: {
            page: this.page,
            page_size: this.page_size,
            title: this.title,
            outerId: this.outerId,
            status: this.status,
            shop_id: this.activeName,
          },
          success: (res) => {
            if (res.data.total) {
              this.tableData = res.data.data
              this.total = res.data.total
              this.page_size = Number(res.data.per_page)
              this.page = res.data.current_page
            }
            setTimeout(() => {
              this.loading = false
            }, 200);
            if (this.total > 0) {
              this.getGoodsList()
            }
          },
          tip: () => {
            this.loading = false
          },
        })
      },
      // 分页
      pagechage(page) {
        this.page = page
        this.tableData = []
        this.getlist()
      },
      handleSizeChange(size) {
        this.page_size = size
        this.tableData = []
        this.getlist()
      },
      //dear商品列表（用于下拉选择）
      getGoodsList() {
        this.$post({
          url: "/app/dear_goods/dearGoodsList",
          data: {
            shop_id: this.activeName,
            page: this.lpage,
            keywords: this.keywords,
          },
          success: (res) => {
            this.ltotala = res.data.total
            res.data.data.forEach(item => {
              item.sku_name = `${item.sku}:${item.name}`
            });
            this.goodsList = res.data.data
            setTimeout(() => {
              this.lloading = false
            }, 1200);
          },
          tip: () => {
            setTimeout(() => {
              this.lloading = false
            }, 1200);
          },
        })
      },
      // dear商品列表（用于下拉选择）分页
      goodsListchange(page) {
        this.lpage = page;
        this.getGoodsList();
      },
      searchlist(data) {
        this.lpage = 1
        this.keywords = data
        this.lloading = true
        this.getGoodsList();
      },
      importgood() {
        this.$router.push(`importgood?id=${this.activeName}&title=${this.title}&status=${this.status}`)
      },
      // 商品全量下载
      skuSyncAll() {
        this.sku_loading = true
        this.$post({
          url: "/app/goods/skuSyncAll",
          data: {
            shop_id: this.activeName,
          },
          success: res => {
            this.$notify({
              title: res.msg,
              type: 'success'
            });
            setTimeout(() => {
              this.sku_loading = false
              this.pagechage(this.page)
            }, 1300);
          },
          tip: () => {
            setTimeout(() => {
              this.sku_loading = false
            }, 1300);
          },
        })
      },
      //下载平台商品
      download() {
        this.btn_loadinga = true
        this.$post({
          url: "/app/goods/download",
          data: {
            shop_id: this.activeName,
          },
          success: res => {
            this.$notify({
              title: res.msg,
              type: 'success'
            });
            setTimeout(() => {
              this.btn_loadinga = false
              this.gettablist()
            }, 1300);
          },
          tip: () => {
            setTimeout(() => {
              this.btn_loadinga = false
            }, 1300);
          },
        })
      },
      //自动匹配
      autoMatch() {
        this.btn_loadingb = true
        this.$post({
          url: "/app/goods/autoMatch",
          data: {
            shop_id: this.activeName,
          },
          success: (res) => {
            this.$notify({
              title: res.msg,
              type: 'success'
            });
            setTimeout(() => {
              this.btn_loadingb = false
            }, 1300);
            this.$nextTick(() => {
              this.pagechage(this.page)
            })
          },
          tip: () => {
            setTimeout(() => {
              this.btn_loadingb = false
            }, 1300);
          },
        })
      },
      // 保存操作
      submit() {
        let obj = {}
        this.tableData.forEach(data => {
          if (data.status == 0 && data.dear_id) {
            obj[data.id] = data.dear_id
          }
        })
        if (this.tableData.some(data => data.status == 0)) {
          if (JSON.stringify(obj) != '{}') {
            this.$confirm(`${this.$t('lg.存在未匹配的商品,此商品的订单下载将会收到影响,是否继续')}?`, this.$t('lg.提示'), {
              confirmButtonText: this.$t('lg.确定'),
              cancelButtonText: this.$t('lg.取消'),
              type: 'warning'
            }).then(() => {
              this.goodssubmit(obj)
            }).catch(() => {
              this.tableData.forEach(data => {
                if (data.status == 0 && data.dear_id) {
                  data.dear_id = ''
                }
              })
            });
          } else {
            this.$message({
              message: this.$t('lg.请选择匹配关系'),
              type: 'warning'
            });
          }
        }
      },
      //确认保存
      goodssubmit(obj) {
        this.btn_loadingc = true
        this.$post({
          url: "/app/goods/submit",
          data: {
            data: JSON.stringify(obj),
            shop_id: this.activeName,
          },
          success: (res) => {
            this.$notify({
              title: res.msg,
              type: 'success'
            });
            setTimeout(() => {
              this.btn_loadingc = false
            }, 1300);
            this.$nextTick(() => {
              this.pagechage(this.page)
            })
          },
          tip: () => {
            setTimeout(() => {
              this.btn_loadingc = false
            }, 1300);
          },
        })
      },
      // 取消匹配
      cancelMatch(data) {
        this.loading = true
        this.$post({
          url: "/app/goods/cancelMatch",
          data: {
            id: data.id,
          },
          success: (res) => {
            this.$notify({
              title: res.msg,
              type: 'success'
            });
            this.$nextTick(() => {
              this.pagechage(this.page)
            })
          },
          tip: () => {
            setTimeout(() => {
              this.loading = false
            }, 1300);
          },
        })
      },
      deleteShop() {
        if (!this.idsarr.length) {
          this.$message({
            message: this.$t('lg.请选择删除商品'),
            type: 'warning'
          });
          return
        }
        let ids = []
        this.idsarr.map((item) => {
          ids.push(item.id)
        })
        this.btn_allunbind = true
        this.$post({
          url: "/app/goods/delGoods",
          data: {
            shop_id: this.activeName,
            ids: ids.join()
          },
          success: (res) => {
            this.$message({
              type: 'success',
              message: res.msg
            });
            setTimeout(() => {
              this.btn_allunbind = false
              this.pagechage(this.page)
            }, 1300);
          },
          tip: () => {

            setTimeout(() => {
              this.btn_allunbind = false
            }, 1300);
          },
        })
      },
      SelectionChange(data) {
        this.idsarr = data
      },
    },
    created() {
      this.gettablist()
    },

  }
</script>
<style lang='scss' scoped>
  .indexbox {
    width: 100%;
    height: 100%;
    .searchbox {
      width: 100%;
      padding: 10px 20px 0px;
      background: #fff;
      border-bottom: 1px solid #babdcd;
    }
    .tablebox {
      width: 100%;
      padding: 20px;
      /deep/ .el-table--border td,
      .el-table--border th,
      .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
        border-right: none;
      }
      /deep/ .el-table--border {
        thead {
          th {
            border-right: 1px solid #ebeef5 !important;
          }
        }
        table {
          td {
            border-right: none !important;
          }
        }
      }
    }
    .formbox {
      /deep/.el-form-item {
        margin-bottom: 30px !important;
        .el-form-item__content {
          width: 100%;
          .el-button {
            width: 100%;
            height: 48px;
            background: $color;
            border-radius: 5px;
            border-color: $color;
          }
        }
      }
      /deep/.el-upload-dragger {
        min-width: 360px;
        width: 100%;
      }
    }
    .dataselect {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    /deep/.el-dialog {
      min-width: 400px !important;
    }
  }
</style>